export default "__VITE_ASSET__3b690afc__"